<template>
  <div>
    <el-table
      v-loading="settings.isLoading"
      border
      stripe
      @selection-change="e => handleClick('select',e)"
      :data="data"
      style="width: 100%"
      :header-cell-style="{'background':'#f5f7fa'}"
    >
      <el-table-column v-if="settings.isSelection" width="55" type="selection" fixed align="center"></el-table-column>
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" fixed align="center"></el-table-column>
      <template v-for="item in header">
        <el-table-column
          v-if="!item.slotName"
          :key="item.prop"
          :type="item.type"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed"
          align="center"
        ></el-table-column>
        <el-table-column
          v-else
          :key="item.prop"
          :label="item.label"
          :width="item.width"
          :fixed="item.fixed"
          align="center"
        >
          <template slot-scope="scope">
            <slot :name="item.slotName" :scope="{row:scope.row, index: scope.$index}"></slot>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      background
      style="text-align:right;padding:6px 0"
      @size-change="e=>handleClick('pageSizeChange',e)"
      @current-change="e=>handleClick('currentPageChange',e)"
      :current-page="currentPage"
      :page-sizes="[5, 10, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="settings.total"
    ></el-pagination>
  </div>
</template>

<script>

export default {
  name: "",
  props: {
    data: { type: Array, default: () => [] },
    header: { type: Array, required: true },
    settings: {
      type: Object,
      default: () => {
        return {
          isLoading: false,
          isSelection: false,
          currentPage: 1,
          pageSize: 10,
          total: 1
        };
      }
    }
  },
  components: {

  },
  computed: {
    currentPage() {
      return this.settings.currentPage;
    },
    pageSize() {
      return this.settings.pageSize;
    }
  },
  methods: {
    handleClick(type, e) {
      this.$emit(type, e);
    },
    actionClick(actionType, row, index) {
      this.$emit(type, {
        row, index
      })
    },
    indexMethod(index) {
      return index + 1 + ((this.currentPage-1)*this.pageSize);
    }
  }
};
</script>

<style lang="" scoped>
</style>